<template>
  <div class="admin-layout" :class="{ 'sider-open': siderOpen }">
    <div class="sider-mask" v-if="siderOpen" @click="siderOpen = false"></div>
    <aside class="admin-sider">
      <div class="sider-brand">
        <span class="brand-mark">ZYT</span>
        <div class="brand-text">
          <strong>中云图</strong>
          <em>内容管理后台</em>
        </div>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="admin-menu"
        router
        background-color="#0f2f4a"
        text-color="#c5d7e8"
        active-text-color="#ffffff"
        @select="siderOpen = false"
      >
        <el-menu-item index="/admin/user">
          <i class="el-icon-user"></i>
          <span slot="title">后台用户管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/news">
          <i class="el-icon-news"></i>
          <span slot="title">新闻资讯管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/cases">
          <i class="el-icon-picture-outline"></i>
          <span slot="title">案例信息管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/team">
          <i class="el-icon-s-custom"></i>
          <span slot="title">团队风采管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/course">
          <i class="el-icon-time"></i>
          <span slot="title">发展历程管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/enterprise">
          <i class="el-icon-office-building"></i>
          <span slot="title">合作企业管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/honor">
          <i class="el-icon-trophy"></i>
          <span slot="title">荣誉墙管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/product">
          <i class="el-icon-s-goods"></i>
          <span slot="title">公司产品管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/dictionary">
          <i class="el-icon-setting"></i>
          <span slot="title">数据字典管理</span>
        </el-menu-item>
      </el-menu>
    </aside>

    <section class="admin-main">
      <header class="admin-topbar">
        <div class="topbar-left">
          <el-button class="sider-toggle" type="text" icon="el-icon-s-fold" @click="siderOpen = !siderOpen"></el-button>
          <div>
            <h1>{{ pageTitle }}</h1>
            <p>湖南中云图地理信息科技有限公司</p>
          </div>
        </div>
        <div class="topbar-actions">
          <el-button type="text" icon="el-icon-house" @click="goHome">返回官网</el-button>
          <el-button type="text" icon="el-icon-switch-button" @click="logout">退出登录</el-button>
        </div>
      </header>
      <main class="admin-content">
        <div class="content-panel">
          <router-view />
        </div>
      </main>
    </section>
  </div>
</template>

<script>
const TITLE_MAP = {
  "/admin/user": "后台用户管理",
  "/admin/news": "新闻资讯管理",
  "/admin/cases": "案例信息管理",
  "/admin/team": "团队风采管理",
  "/admin/course": "发展历程管理",
  "/admin/enterprise": "合作企业管理",
  "/admin/honor": "荣誉墙管理",
  "/admin/product": "公司产品管理",
  "/admin/dictionary": "数据字典管理",
  "/admin/page": "测试分页"
};

export default {
  name: "admin",
  data() {
    return {
      siderOpen: false
    };
  },
  computed: {
    activeMenu() {
      return this.$route.path;
    },
    pageTitle() {
      return TITLE_MAP[this.$route.path] || "内容管理";
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    logout() {
      sessionStorage.removeItem("token");
      this.$router.push("/login");
    }
  }
};
</script>

<style lang="scss" scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
  background: linear-gradient(160deg, #eef4f9 0%, #f7fafc 45%, #edf2f7 100%);
}

.admin-sider {
  width: 232px;
  flex-shrink: 0;
  background: #0f2f4a;
  box-shadow: 4px 0 24px rgba(15, 47, 74, 0.18);
  display: flex;
  flex-direction: column;
}

.sider-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.brand-mark {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1f6fab, #3aa0d8);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-text {
  display: flex;
  flex-direction: column;
  strong {
    color: #fff;
    font-size: 16px;
    line-height: 1.2;
  }
  em {
    margin-top: 4px;
    color: #8fb0c9;
    font-style: normal;
    font-size: 12px;
  }
}

.admin-menu {
  border-right: none !important;
  flex: 1;
  padding: 12px 0;
}

.admin-menu >>> .el-menu-item {
  height: 48px;
  line-height: 48px;
  margin: 4px 10px;
  border-radius: 8px;
}

.admin-menu >>> .el-menu-item.is-active {
  background: linear-gradient(90deg, #1f6fab, #2786c4) !important;
}

.admin-menu >>> .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.06) !important;
}

.admin-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.admin-topbar {
  height: 72px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid #e4edf5;
}

.topbar-left {
  display: flex;
  align-items: center;

  h1 {
    margin: 0;
    font-size: 20px;
    color: #17324a;
    font-weight: 600;
  }
  p {
    margin: 4px 0 0;
    font-size: 12px;
    color: #7a93a8;
  }
}

.topbar-actions {
  .el-button {
    color: #3d5f78;
    margin-left: 8px;
  }
  .el-button:hover {
    color: #1f6fab;
  }
}

.admin-content {
  flex: 1;
  padding: 22px 28px 28px;
}

.content-panel {
  min-height: calc(100vh - 140px);
  background: #fff;
  border: 1px solid #e6eef5;
  border-radius: 14px;
  padding: 22px;
  box-shadow: 0 10px 30px rgba(23, 50, 74, 0.05);
  overflow-x: auto;
}

.sider-toggle {
  display: none;
  margin-right: 8px;
  color: #1f6fab !important;
  font-size: 20px;
}

.sider-mask {
  display: none;
}

@media (max-width: 960px) {
  .sider-toggle {
    display: inline-block;
  }

  .admin-sider {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 130;
    transform: translateX(-105%);
    transition: transform 0.25s ease;
  }

  .admin-layout.sider-open .admin-sider {
    transform: translateX(0);
  }

  .sider-mask {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(8, 28, 46, 0.45);
    z-index: 120;
  }

  .admin-topbar {
    height: auto;
    min-height: 64px;
    padding: 10px 14px;
    flex-wrap: wrap;
    gap: 8px;
  }

  .topbar-left p {
    display: none;
  }

  .admin-content {
    padding: 14px;
  }

  .content-panel {
    padding: 14px;
    border-radius: 10px;
  }
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.table-thumb {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}
</style>
